/* component-tolstoy-stories.js
   Mouse drag-to-scroll for the "See it styled" Tolstoy stories row on the PDP.

   Tolstoy's tiles container is a native horizontal scroller (overflow: auto)
   whose scrollbar is hidden and whose arrow buttons the theme hides to match
   the design (component-tolstoy-stories.css). Trackpads and touch swipe it
   natively; a mouse had only shift+wheel. This lets a mouse press-and-drag pan
   the row. A press that moves less than THRESHOLD px is still a click, so the
   story opens as before; once a drag has started the click that ends it is
   swallowed so the story does not open on release.

   Listeners are delegated on document: the widget renders asynchronously and
   re-renders on product change, so nothing here needs rebinding. Mouse
   pointers only - touch and pen keep the browser's own panning. Loaded with
   defer from theme.liquid on product templates, the only place the block is
   mounted. */
(function () {
  var ROW = '.tolstoy-stories-tiles-container, .tolstoy-stories-container';
  var THRESHOLD = 6;
  var row = null;
  var pointerId = null;
  var startX = 0;
  var startScroll = 0;
  var dragging = false;

  function swallowClick(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  function endDrag(event) {
    if (!row || event.pointerId !== pointerId) return;
    if (dragging) {
      row.classList.remove('is-dragging');
      /* Tolstoy sets scroll-behavior: smooth on the row; it was switched to auto
         for the drag so the row tracks the pointer, and is restored here. */
      row.style.scrollBehavior = '';
      /* The click that follows this pointerup dispatches in the same task, before
         any timer, so removing the capture listener on a 0ms timeout swallows
         exactly that one click and nothing after it. */
      document.addEventListener('click', swallowClick, true);
      setTimeout(function () {
        document.removeEventListener('click', swallowClick, true);
      }, 0);
    }
    row = null;
    pointerId = null;
    dragging = false;
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var target = event.target.closest(ROW);
    if (!target || target.scrollWidth <= target.clientWidth) return;
    row = target;
    pointerId = event.pointerId;
    startX = event.clientX;
    startScroll = target.scrollLeft;
    dragging = false;
  });

  document.addEventListener('pointermove', function (event) {
    if (!row || event.pointerId !== pointerId) return;
    var dx = event.clientX - startX;
    if (!dragging) {
      if (Math.abs(dx) < THRESHOLD) return;
      dragging = true;
      row.classList.add('is-dragging');
      row.style.scrollBehavior = 'auto';
      try {
        row.setPointerCapture(pointerId);
      } catch (error) {
        /* Capture is a nicety (keeps the drag alive outside the row); a pointer
           the browser will not capture just falls back to document tracking. */
      }
    }
    event.preventDefault();
    row.scrollLeft = startScroll - dx;
  });

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  /* The poster <img> would otherwise start a native drag-and-drop ghost image
     the moment the mouse moves with the button down. */
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest && event.target.closest(ROW)) event.preventDefault();
  });
})();
